import { useMutation } from "react-query";
import { updateAdditionalDiagnosis } from "api/customers";
import { useGlobalToast } from "components/GlobalToastProvider";

const useUpdateAdditionalDiagnosis = (options: Record<string, any> = {}) => {
  const { onSuccess = () => {}, onError = () => {}, ...otherOptions } = options;
  const { showToast } = useGlobalToast();

  const { mutate, isLoading, ...rest } = useMutation(
    ({ id, payload }: { id: number; payload: Record<string, any> }) =>
      updateAdditionalDiagnosis(id, payload),
    {
      onSuccess: (response, variables) => {
        showToast({ message: "Additional diagnosis updated successfully." });
        onSuccess(response, variables);
      },
      onError: (error: any) => {
        const errorMessage =
          error?.response?.data?.error || "Failed to update additional diagnosis";
        showToast({ message: errorMessage, errorState: true });
        onError(error);
      },
      ...otherOptions,
    }
  );

  return {
    updateAdditionalDiagnosisMutation: mutate,
    isUpdateAdditionalDiagnosisLoading: isLoading,
    ...rest,
  };
};

export default useUpdateAdditionalDiagnosis;
